import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ThemeIconSizeVariable, ThemeSpaceVariable, } from '@caspeco/casper-ui-library.base-ui.theme';
import { FormLabel as ChakraFormLabel, } from '@chakra-ui/react';
import { Icon } from '@caspeco/casper-ui-library.components.icon';
/**
 * Used to enhance the usability of form controls.
 * It is used to inform users as to what information is requested for a form field.
 * Every form field should have a form label.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/formcontrol
 */
export function FormLabel({ children, icon, ...props }) {
    return (_jsxs(ChakraFormLabel, { ...props, children: [icon && (_jsx(Icon, { size: ThemeIconSizeVariable.Small, icon: icon, mr: ThemeSpaceVariable.XSmall })), children] }));
}
//# sourceMappingURL=formlabel.js.map